import { app } from '../app';

app.directive('preventDefault', preventDefault);

/** @ngInject */
function preventDefault() {
        return {
            restrict : 'A',
            link : function(scope, element, attrs) {
                $(element).on("click", function(event) {
                    event.preventDefault();
                });
            }
        };
}



// WEBPACK FOOTER //
// ./src/portal/directives/prevent-default.directive.js